import { render, staticRenderFns } from "./ProfileProjectCard.vue?vue&type=template&id=5f9104b1&scoped=true&"
import script from "./ProfileProjectCard.vue?vue&type=script&lang=js&"
export * from "./ProfileProjectCard.vue?vue&type=script&lang=js&"
import style0 from "./ProfileProjectCard.vue?vue&type=style&index=0&id=5f9104b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9104b1",
  null
  
)

export default component.exports